<template>
  <div class="container">
    <div class="btn-wrapper">
      <el-button class="add-new-btn" @click="handleViewAdd(1)">
        <i class="iconfont iconProperty1tianjia"></i> Add
      </el-button>
    </div>
    <div class="risk-table risklist-table">
      <el-table
        ref="table"
        :data="list"
        :height="tableHeight"
        :indent="0"
        v-loading="loading"
        header-row-class-name="table-header-row"
        border
        row-key="rowId"
      >
        <template slot="empty">
          <Empty />
        </template>
        <el-table-column label="ID" prop="id" min-width="96px"></el-table-column>
        <el-table-column label="Name" min-width="118px">
          <template v-slot="{row}">
            <div>
              <span>{{row.name}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="Operation" min-width="155px">
          <template v-slot="{row}">
            <div v-if="row.riskLevelId != 0">
              <el-button class="table-inner-btn" @click="handleViewAdd(2,row)">Modify</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <div class="pagination-wrapper inline-wrapper">
      <el-pagination
        class="inline-right"
        :total="total"
        :current-page="queryData.current"
        :page-size="queryData.size"
        :page-sizes="[50, 100, 200]"
        @current-change="changePage"
        @size-change="handleSizeChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div> -->

    <dia ref="dialogDom" class="label-dialog">
      <!-- 添加1修改2 -->
      <div v-if="num == 2 || num == 1">
        <el-form :model="queryForm" label-width="100px" style="padding: 30px 0">
          <el-form-item label="Tag Name">
            <el-input v-model="queryForm.name"></el-input>
          </el-form-item>
        </el-form>
        <div class="dialog-footer table-search-part">
          <el-button class="search-btn" v-if="num == 1" @click="handleListAdd()">Confirm</el-button>
          <el-button class="search-btn" v-if="num == 2" @click="handleListModify()">Confirm</el-button>
          <el-button class="clear-btn" @click="listClose()">Cancel</el-button>
        </div>
      </div>
    </dia>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import dia from "@/components/dialog/index";
import Empty from "@/components/empty/index";
import {
  getRiskTagList,
  getRiskTagUpdate,
  getRiskTagAdd
} from "@/api/orderRiskTag";

export default {
  name: "RiskList",
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      queryData: {
        // current: 1,
        // size: 50
      },
      queryForm: {
        name: ""
      },
      tableHeight: window.innerHeight,
      title: "",
      num: ""
    };
  },
  methods: {
    async getList() {
      this.loading = true;
      try {
        const res = await getRiskTagList(this.queryData);
        const data = res.data || [];
        this.list = data
        // this.total = data.total;
        this.loading = false;
      } catch (error) {
        this.list = [];
        this.loading = false;
      }
    },
    // 分页
    changePage(e) {
    //   this.queryData.current = e;
      this.getList();
    },
    // 列表显示条目
    handleSizeChange(e) {
    //   this.queryData.size = e;
    //   this.queryData.current = 1;
      this.getList();
    },
    // 查看详情
    // handleViewDetail(data) {
    //   this.$router.push({
    //     path: "/risk/detail",
    //     query: { riskLevelId: data.riskLevelId }
    //   });
    // },
    // 修改或者添加
    // handleViewModify(data) {
    //   this.$router.push({
    //     path: "/risk/modify",
    //     query: { riskLevelId: data.riskLevelId }
    //   });
    // },
    // 添加
    // handleViewAdd(data) {
    //   this.$router.push({ path: "/risk/add" });
    // },
    handleViewAdd(num, data) {
      this.num = num;
      if (num == 1) {
        // 添加
        this.title = "Add Order Risk Tag";
        this.queryForm.name = "";
        this.queryForm.id = "";
        this.$refs["dialogDom"].isShowDia(this.title, true, "460px");
      } else if (num == 2) {
        // 修改
        this.title = "Modify Order Risk Tag";
        this.queryForm.name = data.name;
        this.queryForm.id = data.id;
        this.$refs["dialogDom"].isShowDia(this.title, true, "460px");
      }
    },
    async handleListAdd(data) {
      let param = { ...this.queryForm };
      try {
        const res = await getRiskTagAdd(param);
        if (res.success) {
          this.$message({ message: "update success", type: "success" });
          this.getList();
          this.listClose();
        }
      } catch (error) {
        this.listClose();
      }
    },
    async handleListModify(data) {
      let param = { ...this.queryForm };
      try {
        const res = await getRiskTagUpdate(param);
        if (res.success) {
          this.$message({ message: "update success", type: "success" });
          this.getList();
          this.listClose();
        }
      } catch (error) {
        this.listClose();
      }
    },
    listClose() {
      this.$refs["dialogDom"].isShowDia(this.title, false, "460px");
    },
  },
  activated() {
    this.getList();
    this.$nextTick(() => {
      let self = this;
      self.tableHeight =
        window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      window.onresize = function() {
        self.tableHeight =
          window.innerHeight - self.$refs.table.$el.offsetTop - 94;
      };
    });
  },
  components: {
    dia,
    Empty
  }
};
</script>

<style lang="scss" scoped>
.btn-wrapper {
  margin: 20px 0;
}
/deep/.risk-table {
  .el-table th {
    padding: 6px 0;
  }
}
</style>
